export const colors = {
  primaryOrange: "#F27930",
  PrimaryWhite: "#FFFFFF",
  SecondaryMidnightBlue: "#143A72",
  PrimaryWoodSmoke: "#171A21",
  NeutralDark600: "#505662",
  NeutralMIdDark400: "#737881",
  NeutralDark700: "#424752",
  SecondarySummerSky: "#3597EC",
  ExtendedPalatePunchP800: "#E15951",
  ExtendedPalettesSummerSkySS100: "#EBF5FD",
  NeutralMidN500: "#626772",
  ExtendedPalateCyberYellowCy100: "#FFFBEB",
  NeutralLightN60: "#EEEEEF",
  NeutralLightN80: "#CBCCD0", //button border color(check now)
  ExtendedpalettesIrishGreenIG200: "#CEEBDC",
  ExtendedpalettesIrishGreenIG300: "#B5E1CA",
  ExtendedpalettesIrishGreenIG100: "#E6F5ED",
  ExtendedpalettesIrishGreenIG400: "#9DD7B9",
  ExtendedpalettesIrishGreenIG600: "#6BC295",
  ExtendedpalettesMidnightBlueMB400: "#A1B0C7",
  ExtendedpalettesMidnightBlueMB600: "#7289AA",
  ExtendedpalettesOrangeO600: "#F7AF83",
  ExtendedpalettesOrange0800: "#F59459",
  ExtendedpalettesSummerSkySS800: "#5DACF0",
  NeutralsMidN500: "#626772",
  PrimaryOrange: "#F27930",
  SecondaryIrishGreen: "#099A4F",
  ExtendedpalettesPunchP800: "#E15951",
  NeutralsMidN200: "#969AA1",
  NeutralsMidN300: "#858991",
  GradientAlertslightinformation: "rgba(51, 168, 226, 1)",
  ColorButtonPrimarysurface: "#97144D",
  ColorpalettePrimaryMidnight: "#143A72",
  ColorSurfacebgboldIrishGreen: "#077D3A",
  ColorpaletteInformation400: "#99D3F1",
  ColorpaletteWarning600: "#FFDB79",
  ColorpaletteExtendedBurgundy200: "#EAD0DB",
  ColorpaletteSuccess300: "#B5D8C4",
  Grey: "grey",
  sucess: "#22bb33",
  black: "#000000",
  mediumgrey: "#7A7777",
  BroadDaylight: "#C5DCFF",
  red: "red",
  Gunmetal: "#2F343A",
  Platinum: "#E6E6E6",
  WhiteSmoke: "#F5F5F5",
  DarkGrey: "#555",
  LightSlateGray: "#f5f7f9",
  indigo: "#003A70",
  AntiFlashWhite: "#F1F1F1",
  ashgrey: "#6B7280",
  TardisBlue: "#003A70",
  lavendershade: "#A8ABB1",
  darkBlue: "#173F78",
  cloudGray: "#F4F6FA",
  softGray: "#E8EBF1",
};
